import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mq } from '@utils/responsive';
import { getSectionSpacing } from '@utils/space';

const Wrapper = styled.div`
  display: flow-root;
  padding-bottom: ${(props) => props.$spacing.mobile}px;

  ${mq.gtsm`
    padding-bottom: ${(props) => props.$spacing.desktop}px;
  `}
`;

function Section({ children, spacing }) {
  return <Wrapper $spacing={getSectionSpacing(spacing)}>{children}</Wrapper>;
}

Section.propTypes = {
  spacing: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default Section;
